import { Suspense } from "react";
import { useAtomValue } from "jotai";
import { Text, ServiceIcons, SkeletonText } from "@zapier/design-system";
import { agentAtomFamily_SUSPENDS } from "@zapier/canvas-state";
import styles from "./AgentPreview.module.css";

type Props = {
  agentId: string;
};

function SuspendedAgentPreview({ agentId }: Props) {
  const agent = useAtomValue(agentAtomFamily_SUSPENDS(agentId));

  if (!agent) {
    return null;
  }

  const hasInstructions = Boolean(agent.workflow.instructions);

  return (
    <div className={styles.root}>
      <div>
        <ServiceIcons
          hasBorder
          maxServices={3}
          size="small"
          services={[
            {
              name: "Google Forms",
              src: "https://zapier-images.imgix.net/storage/services/2554f3f9544cf8375a46f68b18de0e7d.png",
            },
            {
              name: "Google Sheets",
              src: "https://zapier-images.imgix.net/storage/services/8913a06feb7556d01285c052e4ad59d0.png",
            },
            {
              name: "Gmail",
              src: "https://zapier-images.imgix.net/storage/services/54f0bd6f9c31b757ab20d4c7058dc7c0.png",
            },
            {
              name: "Google Calendar",
              src: "https://zapier-images.imgix.net/storage/services/62c82a7958c6c29736f17d0495b6635c.png",
            },
            {
              name: "Slack",
              src: "https://zapier-images.imgix.net/storage/services/6cf3f5a461feadfba7abc93c4c395b33_2.png",
            },
            {
              name: "GitHub",
              src: "https://zapier-images.imgix.net/storage/services/c63f7c57dc0afb733535a5adccce4d01.png",
            },
            {
              name: "Asana",
              src: "https://zapier-images.imgix.net/storage/developer/986718c45d823ca0a4173ec68912416e.png",
            },
          ]}
        />
      </div>
      <Text type="Body2Multiline" color="GrayWarm9">
        {agent.name}
      </Text>
      {hasInstructions && (
        <Text type="SmallPrint1" color="TextWeakest">
          {agent.workflow.instructions}
        </Text>
      )}
    </div>
  );
}

function AgentPreviewLoader() {
  return (
    <SkeletonText
      lines={3}
      size="body"
      textAlign="left"
      width="100%"
      color="GrayWarm3"
    />
  );
}

export function AgentPreview({ agentId }: Props) {
  return (
    <Suspense fallback={<AgentPreviewLoader />}>
      <SuspendedAgentPreview agentId={agentId} />
    </Suspense>
  );
}
